<template>
  <div>
    <div>
      <v-menu :disabled="disableMenu">
        <template v-slot:activator="{ on: menu, attrs }">
          <v-tooltip bottom>
            <template v-slot:activator="{ on: tooltip }">
              <v-chip
                small
                outlined
                :color="model.color"
                dark
                label
                v-bind="attrs"
                v-on="{ ...tooltip, ...menu }"
              >
                <v-icon :color="model.color" class="pl-2" small>{{
                  model.icon
                }}</v-icon>
                <span>{{ model.text }}</span>
              </v-chip>
            </template>
            <span>الحالة</span>
          </v-tooltip>
        </template>

        <v-card class="text-center" width="200">
          <v-list>
            <v-list-item class="m-0">
              <v-list-item-content v-if="model">
                <v-list-item-title class="text-h6"
                >تغيير الحالة من</v-list-item-title
                >
                <v-list-item-subtitle>
                  <v-chip label small outlined :color="model.color">
                    <v-icon small :color="model.color">{{ model.icon }}</v-icon
                    >{{ model.text }}
                  </v-chip>
                </v-list-item-subtitle>
                <v-list-item-subtitle> إلى: </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-divider class="m-1" />
            <v-list-item-action class="mt-0">
              <v-list-item-title
                v-if="state == 1"
                v-can="'Trips.Close'"
                class="m-1"
              >
                <v-chip
                  label
                  outlined
                  :color="filtered[0].color"
                  style="cursor: pointer"
                  @click="$emit('changeState', filtered[0].value)"
                >
                  <v-icon :color="filtered[0].color">{{
                    filtered[0].icon
                  }}</v-icon
                  >{{ filtered[0].text }}
                </v-chip>
              </v-list-item-title>
              <v-list-item-title
                v-else-if="state == 2"
                v-can="'Trips.Open'"
                class="m-1"
              >
                <v-chip
                  label
                  outlined
                  :color="filtered[0].color"
                  style="cursor: pointer"
                  @click="$emit('changeState', filtered[0].value)"
                >
                  <v-icon :color="filtered[0].color">{{
                    filtered[0].icon
                  }}</v-icon
                  >{{ filtered[0].text }}
                </v-chip>
              </v-list-item-title>
              <v-list-item-title v-can="'Trips.Transfer'" class="m-1">
                <v-chip
                  label
                  outlined
                  :color="filtered[1].color"
                  style="cursor: pointer"
                  @click="$emit('changeState', filtered[1].value)"
                >
                  <v-icon :color="filtered[1].color">{{
                    filtered[1].icon
                  }}</v-icon
                  >{{ filtered[1].text }}
                </v-chip>
              </v-list-item-title>
            </v-list-item-action>
          </v-list>
        </v-card>
      </v-menu>
    </div>
  </div>
</template>

<script>
export default {
  props: ["state", "options", "optionsChange", "disableMenu"],
  mounted() {},
  created() {},
  computed: {
    classE() {
      return {
        color: `${this.model.color} darken-2`,
      };
    },
    model() {
      const member = this.getEnumMember(this.options, +this.state);
      return member;
    },
    filtered() {
      return this.optionsChange.filter((e) => e.value != +this.state);
    },
  },
  watch: {
    options() {},
  },
};
</script>

<style>
</style>
